/**
 * Wrapper for window.location.assign to enable testability.
 */
export const navigateToUrl = (url: string) => window.location.assign(url);
